import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1EmployeeImportExportRetrieve: build.query<
      ApiPortalV1EmployeeImportExportRetrieveApiResponse,
      ApiPortalV1EmployeeImportExportRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/import/export/`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiPortalV1EmployeeImportImportCreate: build.mutation<
      ApiPortalV1EmployeeImportImportCreateApiResponse,
      ApiPortalV1EmployeeImportImportCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/import/import/`,
        method: "POST",
        body: queryArg.body,
        params: {
          mode: queryArg.mode,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiPortalV1EmployeeImportImportRecordsCreate: build.mutation<
      ApiPortalV1EmployeeImportImportRecordsCreateApiResponse,
      ApiPortalV1EmployeeImportImportRecordsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/import/import-records/`,
        method: "POST",
        body: queryArg.fileUpload,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiPortalV1EmployeeImportRecordTemplateRetrieve: build.query<
      ApiPortalV1EmployeeImportRecordTemplateRetrieveApiResponse,
      ApiPortalV1EmployeeImportRecordTemplateRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/import/record-template/`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiPortalV1EmployeeImportTemplateRetrieve: build.query<
      ApiPortalV1EmployeeImportTemplateRetrieveApiResponse,
      ApiPortalV1EmployeeImportTemplateRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/import/template/`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1EmployeeImportExportRetrieveApiResponse =
  /** status 200  */ Blob;
export type ApiPortalV1EmployeeImportExportRetrieveApiArg = {
  /** ID of the organization */
  organizationId: number;
};
export type ApiPortalV1EmployeeImportImportCreateApiResponse =
  /** status 200  */ object;
export type ApiPortalV1EmployeeImportImportCreateApiArg = {
  /** Import mode: 1 to create new employees, 2 to update existing employees */
  mode: number;
  /** ID of the organization */
  organizationId: number;
  body: Blob;
};
export type ApiPortalV1EmployeeImportImportRecordsCreateApiResponse =
  /** status 200  */ object;
export type ApiPortalV1EmployeeImportImportRecordsCreateApiArg = {
  /** ID of the organization */
  organizationId: number;
  fileUpload: FileUpload;
};
export type ApiPortalV1EmployeeImportRecordTemplateRetrieveApiResponse =
  /** status 200  */ Blob;
export type ApiPortalV1EmployeeImportRecordTemplateRetrieveApiArg = {
  /** ID of the organization */
  organizationId: number;
};
export type ApiPortalV1EmployeeImportTemplateRetrieveApiResponse =
  /** status 200  */ Blob;
export type ApiPortalV1EmployeeImportTemplateRetrieveApiArg = {
  /** ID of the organization */
  organizationId: number;
};
export type FileTypeEnum = 1 | 2 | 3 | 4;
export type FileUploadStatusEnum = 1 | 2 | 3 | 4 | 9;
export type FileUpload = {
  name?: string | null;
  file_type?: FileTypeEnum;
  data_file: string;
  review_data?: any | null;
  status?: FileUploadStatusEnum;
  messages?: string | null;
  organization?: number | null;
  created_by?: number | null;
  row_id?: number;
  row_info?: any | null;
  delete_row?: number;
  import_to_db?: number;
  re_process_data?: number;
  delete_if_not_uploaded?: number;
  create_update_record?: number;
};
export type FileUploadRead = {
  id: number;
  name?: string | null;
  file_type?: FileTypeEnum;
  data_file: string;
  review_data?: any | null;
  status?: FileUploadStatusEnum;
  status_text: string;
  messages?: string | null;
  organization?: number | null;
  created_by?: number | null;
  created_at: string;
  updated_at: string;
  row_id?: number;
  row_info?: any | null;
  delete_row?: number;
  import_to_db?: number;
  re_process_data?: number;
  delete_if_not_uploaded?: number;
  create_update_record?: number;
};
export const {
  useApiPortalV1EmployeeImportExportRetrieveQuery,
  useApiPortalV1EmployeeImportImportCreateMutation,
  useApiPortalV1EmployeeImportImportRecordsCreateMutation,
  useApiPortalV1EmployeeImportRecordTemplateRetrieveQuery,
  useApiPortalV1EmployeeImportTemplateRetrieveQuery,
} = injectedRtkApi;
